<template>
  <div style="height: 100%">
    <div class="columns is-fullheight">
      <div
        class="column is-2 is-sidebar-menu is-hidden-mobile is-hidden-tablet-only"
      >
        <aside class="menu">
          <div class="menu-header">
            <img src="/home/images/logos/logo_white.png" /><br />
            {{ user.firstname }} {{ user.lastname }}<br />

            <div class="connected">
              <div>
                <img
                  src="/home/images/green-dot.png"
                  style="width: 7px; margin-right: 5px"
                  alt="connected"
                />
              </div>
              <div>
                <small>{{ $t("layout.connected") }}</small>
              </div>
            </div>
          </div>

          <ul class="menu-list">
            <li>
              <router-link :to="'/installations'">
                <b-icon icon="home" size="is-small"></b-icon> &nbsp;&nbsp;{{
                  $t("layout.links.installations")
                }}
              </router-link>
            </li>
            <li>
              <router-link :to="'/notifications'">
                <b-icon icon="information-outline" size="is-small"></b-icon>
                &nbsp;&nbsp;{{ $t("layout.links.notifications") }}
              </router-link>
            </li>

            <li>
              <router-link :to="'/user'">
                <b-icon icon="account" size="is-small"></b-icon> &nbsp;&nbsp;{{
                  $t("layout.links.user")
                }}
              </router-link>
            </li>

            <li>
              <a @click="logout()">
                <b-icon icon="exit-to-app" size="is-small"></b-icon>
                &nbsp;&nbsp;{{ $t("layout.links.logout") }}</a
              >
            </li>
          </ul>
        </aside>
      </div>
      <div class="column is-main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { mapState } from "vuex";
import BIcon from "buefy/src/components/icon/Icon";

export default {
  components: { BIcon },
  name: "home",
  computed: {
    ...mapState("user", {
      user: "current",
    }),

    routes: function () {
      return this.$router.options.routes
        .find((route) => route.name === "Home")
        .children.map((link) => {
          return {
            path: link.path,
            name: link.name,
          };
        });
    },
  },

  methods: {
    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "Login" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.connected {
  display: flex;
  align-items: center;
  justify-content: center;
}

.columns.is-fullheight {
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  margin: 0 !important;

  .column {
    overflow-y: auto;
  }

  .is-main-content {
    padding: 0;
    background: #f9f9f9;
  }

  .is-sidebar-menu {
    /*background: #4a4a4a;*/
    background: #1d1d1b;

    .menu-header {
      color: white;
      margin-top: 1em;

      img {
        width: 75%;
      }

      small {
        font-size: 0.7em;

        font {
          color: greenyellow;
        }
      }
    }

    li * {
      text-align: left;

      font-size: 1.1em;

      margin-bottom: 0.1em;
      color: white;
      .icon {
        //FIX VERTICAL ICON CENTERING
        position: relative;
        top: 2px;
      }
    }

    li *:hover {
      color: black;

      .icon {
        color: black;
      }
    }
  }
}

.menu-list {
  margin-top: 15px;

  a {
    padding: 0.5em 0.4em;
  }
}

.title {
  margin: 5rem 0;
}
</style>
